import { API_URL } from "../utils";
import { DeleteCardRequest } from "../types/requests";

export default async (request: DeleteCardRequest): Promise<boolean> =>  {
	const headers = new Headers();

	const result: { data: boolean, errors?: string } = await (await fetch(`${API_URL}/cards/delete?id=${request.cardId}`, {
		headers,
		credentials: 'include'
	})).json();

	return result.data;
};
